import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _isLoading = new BehaviorSubject<boolean>(true);

  setIsLoading(value) {
    this._isLoading.next(value);
  }

  get isLoading(): Observable<boolean> {
    return this._isLoading.asObservable();
  }
}
